/**
 * @typedef IconProps
 * @property {string} icon
 * @property {string} color
 * @property {string} bgColor
 * @property {string} animation
 * @property {'x-small' | 'small' | 'default' | 'large' | 'x-large'} size
 * @property {string} padding
 */
export class ModelIconProps {
  constructor() {
    this.icon = null;
    this.color = null;
    this.bgColor = null;
    this.animation = null;
    this.size = 'default';
    this.padding = null;
  }
}
